import ReportService from "../ReportService"
import DeliveryService from "../DeliveryService"

const Report = {
    formData(data) {
        let form = new FormData()
        for (let obj in data) {
            form.append(obj, data[obj])
        }
        return form
    },
    get(params) {
        var queryString = Object.keys(params)
            .map(key => key + "=" + params[key])
            .join("&");
        return ReportService.get(`/delivery/orders?` + queryString)
    },
    dashboard(params) {
        var queryString = Object.keys(params)
            .map(key => key + "=" + params[key])
            .join("&");
        return ReportService.get(`/delivery/dashboard?` + queryString)
    },
    heatmap(data) {
        return DeliveryService.post(`/console/report/location`, data)
    },
    basket(data) {
        return DeliveryService.post(`/console/report/product`, data)
    },
    shop(data) {
        return DeliveryService.post(`/console/report/shop`, data)
    },
    category(data) {
        return DeliveryService.post(`/console/report/category`, data)
    }
}


export default Report